"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Qualifier = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _Radio = _interopRequireDefault(require("../../../fields/Radio/Radio"));

var _FieldInfo = _interopRequireDefault(require("../../../form/FieldInfo"));

var _Form = require("../../../form/Form");

var _gaPushToDataLayer = _interopRequireDefault(require("../../../utils/gaPushToDataLayer"));

var _preQualifiersConfig = require("../preQualifiersConfig");

var _base = require("../../../types/base");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-cycle
var HTMLInputEvent = _flowRuntime["default"].tdz(function () {
  return _base.HTMLInputEvent;
});

var QualifierDefinition = _flowRuntime["default"].tdz(function () {
  return _preQualifiersConfig.QualifierDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("hideButton", _flowRuntime["default"]["function"](_flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("qualifier", _flowRuntime["default"].ref(QualifierDefinition)), _flowRuntime["default"].property("optionSelected", _flowRuntime["default"]["boolean"]())));

var correctAnswer = function correctAnswer(desiredAnswer, optionSelected) {
  var desiredAnswers = {
    Yes: true,
    No: false
  };
  return desiredAnswer && !!desiredAnswers[desiredAnswer] === optionSelected;
};

var Qualifier = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Qualifier, _React$Component);

  var _super = (0, _createSuper2["default"])(Qualifier);

  function Qualifier() {
    var _this;

    (0, _classCallCheck2["default"])(this, Qualifier);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleChange = function (e) {
      var _this$props = _this.props,
          hideButton = _this$props.hideButton,
          desiredAnswer = _this$props.qualifier.desiredAnswer;
      var value = e.target.value;
      var booleanValue = value === 'true';

      if (correctAnswer(desiredAnswer, booleanValue)) {
        return undefined;
      }

      return hideButton();
    };

    return _this;
  }

  (0, _createClass2["default"])(Qualifier, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var radio = this.props.qualifier.radio; // Timeout required here so that if there is a history change event, it happens first

      setTimeout(function () {
        (0, _gaPushToDataLayer["default"])("".concat(window.location.pathname, "-").concat(radio.key), radio.title || radio.key);
      }, 100);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$qualifier = this.props.qualifier,
          radio = _this$props$qualifier.radio,
          desiredAnswer = _this$props$qualifier.desiredAnswer,
          otherAnswer = _this$props$qualifier.otherAnswer,
          failContent = _this$props$qualifier.failContent,
          info = _this$props$qualifier.info;
      var optionSelected = this.props.optionSelected;

      if (optionSelected === undefined) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "group"
        }, /*#__PURE__*/_react["default"].createElement(_Radio["default"], {
          key: radio.key,
          id: radio.key,
          radio: radio,
          onChange: this.handleChange
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "row"
        }, info && /*#__PURE__*/_react["default"].createElement(_FieldInfo["default"], {
          className: radio.key,
          info: info
        })));
      }

      if (correctAnswer(desiredAnswer, optionSelected)) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "group"
        }, /*#__PURE__*/_react["default"].createElement("h3", {
          className: "col span_10_of_12"
        }, radio.title), /*#__PURE__*/_react["default"].createElement("div", {
          className: "col span_2_of_12 completed"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "answer"
        }, /*#__PURE__*/_react["default"].createElement("span", null, "Answered"), /*#__PURE__*/_react["default"].createElement("span", null, desiredAnswer))));
      }

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "group"
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "col span_10_of_12"
      }, radio.title), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col span_2_of_12"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "answer failed"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Answered"), /*#__PURE__*/_react["default"].createElement("span", null, otherAnswer)))), /*#__PURE__*/_react["default"].createElement("div", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: failContent
        }
      }));
    }
  }]);
  return Qualifier;
}(_react["default"].Component);

exports.Qualifier = Qualifier;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var parentKey = ownProps.parentKey;

  var _ref = ownProps && ownProps.qualifier.radio,
      key = _ref.key;

  return {
    optionSelected: selector(state, "".concat(parentKey, ".").concat(key))
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps)(
/*#__PURE__*/
// waiting on: Missing React.forwardRef definition #6103
// https://github.com/facebook/flow/issues/6103
// $FlowFixMe WEB-352
_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_Form.ButtonContext.Consumer, null, function (_ref2) {
    var hideButton = _ref2.hideButton;
    return /*#__PURE__*/_react["default"].createElement(Qualifier, Object.assign({}, props, {
      hideButton: hideButton,
      ref: ref
    }));
  });
}));

exports["default"] = _default;